<template>
    <!-- The one checkmark (DESIGN.md 1): a green tick in a light green circle, as on the Strategy checklist.
         For anything done, approved, published or claimed. Not for a checkbox or a button's icon.
         Inside a blue pill (a published date) it takes the pill's blue: tone="blue". -->
    <svg
        role="img"
        :aria-label="label"
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        :stroke="tone === 'blue' ? '#2563eb' : '#17643a'"
        stroke-width="2"
        class="inline-block shrink-0 align-middle"
    >
        <circle cx="12" cy="12" r="10" :fill="tone === 'blue' ? '#ffffff' : '#e3f6ec'"></circle>
        <path d="m7.5 12.5 3 3 6-6.5"></path>
    </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ size?: number; label?: string; tone?: 'green' | 'blue' }>(), { size: 22, label: 'Done', tone: 'green' })
</script>
